import React, { useState, useEffect } from 'react';
import './Sequence.css';

const SequenceResult = ({ answer }) => {
    const [imageView, setImageView] = useState(false);

    useEffect(() => {
        if (Array.isArray(answer) && answer.length > 0) {
            setImageView(Boolean(answer[0]?.attachment_link));
        }
    }, [answer]);

    if (!Array.isArray(answer)) {
        console.error("SequenceResult expected 'answer' to be an array but received:", answer);
        return <div>Данные отсутствуют</div>;
    }

    // console.log(answer)

    return (
        <div className='sequenceResult__container'>
            <div className='sequenceResult__group'>
                {answer.map((answerItem, index) => (
                    imageView ? (
                        <img
                            className='sequenceResult__answerImage'
                            style={{ borderColor: answerItem.selected ? '#22C532' : '#FF0000' }}
                            alt=''
                            src={answerItem.attachment_link}
                            key={index}
                        />
                    ) : (
                        <div className='sequenceResult__answer_wrap'>
                            <div className='sequenceResult__answerNum'>{index+1}<div className={ answerItem.selected ? 'sequenceResult__answer_true' : 'sequenceResult__answer_false'}></div></div>
                            <div
                                className='sequenceResult__answer'
                                style={{ borderColor: answerItem.selected ? '#22C532' : '#FF0000' }}
                                key={index}
                            >
                                {answerItem.text}
                            </div>
                        </div>
                    )
                ))}
            </div>
        </div>
    );
};

export default SequenceResult;
